import type { Token } from "./types"

export interface TokenNative {
  native: {
    decimal_places: number
    denom: string
    [k: string]: unknown
  }
}

export const getTokenDecimals = (token: Token): number => {
  return "native" in token
    ? token.native.decimal_places
    : token.cw20.decimal_places
}
